// extracted by mini-css-extract-plugin
export default {"qr_box":"index_qr_box_JRuz-"};